import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../auth.service';
import { TOTP_CODE_LENGTH } from '../../shared/components/otp-input/otp-input.component';
import { isChallengeExpired, twoFactorErrorMessage } from './two-factor-errors';

@Component({
  selector: 'app-two-factor-enrollment',
  templateUrl: './two-factor-enrollment.component.html'
})
export class TwoFactorEnrollmentComponent implements OnInit {
  /**
   * 'login'    – wymuszony enrollment podczas logowania (token challenge; po
   *              potwierdzeniu kodem backend wystawia pełny JWT)
   * 'settings' – opt-in zalogowanego użytkownika (zwykły JWT)
   */
  @Input() mode: 'login' | 'settings' = 'settings';
  @Output() completed = new EventEmitter<void>();

  loadingSetup = true;
  qrDataUri = '';
  secret = '';
  code = '';
  enabling = false;
  showManualKey = false;

  constructor(private authService: AuthService, private toastr: ToastrService) {}

  ngOnInit() {
    const setup$ = this.mode === 'login'
      ? this.authService.setupTwoFactorChallenge()
      : this.authService.setupTwoFactor();

    setup$.subscribe((res: any) => {
      this.qrDataUri = res.qrDataUri;
      this.secret = res.secret;
      this.loadingSetup = false;
    }, (error: HttpErrorResponse) => {
      this.loadingSetup = false;
      if (this.handleChallengeExpired(error)) { return; }
      this.toastr.error(twoFactorErrorMessage(error, 'Nie udało się rozpocząć konfiguracji 2FA'));
    });
  }

  isComplete(code: string): boolean {
    return (code || '').length === TOTP_CODE_LENGTH;
  }

  confirm(code: string) {
    if (this.enabling || !this.isComplete(code)) { return; }
    this.enabling = true;

    const enable$ = this.mode === 'login'
      ? this.authService.enableTwoFactorChallenge(code)
      : this.authService.enableTwoFactor(code);

    enable$.subscribe(() => {
      this.enabling = false;
      this.completed.emit();
    }, (error: HttpErrorResponse) => {
      this.enabling = false;
      this.code = '';
      if (this.handleChallengeExpired(error)) { return; }
      this.toastr.error(twoFactorErrorMessage(error, 'Nieprawidłowy kod uwierzytelniający'));
    });
  }

  private handleChallengeExpired(error: HttpErrorResponse): boolean {
    if (this.mode === 'login' && isChallengeExpired(error)) {
      this.authService.abandonTwoFactorChallenge('Sesja logowania wygasła. Zaloguj się ponownie.');
      return true;
    }
    return false;
  }
}
